<template>
  <div @click.stop="$parent.$parent.onEditer(index)" class="drag optional" :class="{selected:index === selectedIndex}">
    <div>
      <div :style="{background:item.style.background}">
        <el-row>
          <el-col :span="5" style="background-color: #e8e8e8;" :style="{height:phoneHeight + 'px'}">
            <ul>
              <li v-for="(item_left,index) in item.data" :key="index" @click="selIndex=index"
                  :class="{itemActive:selIndex=== index}"
                  style="text-align: center;cursor: pointer" class="p-v-10">
                {{ item_left.categoryName }}
              </li>
            </ul>
          </el-col>
          <el-col :span="19" class="diy-navBar">
            <ul class="list column-3">
              <li class="item" :key="index" v-for="(navBar,index) in itemList">
                <div class="item-image">
                  <img v-img-url="navBar.imgUrl">
                </div>
                <div class="item-text text-ellipsis">
                  {{ navBar.text }}
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
      <div class="btn-edit-del">
        <div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">删除</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Category',
  props: ['item', 'index', 'selectedIndex', 'phoneHeight'],
  data () {
    return {
      selIndex: 0
    }
  },
  computed: {
    itemList () {
      let list = []
      let index = this.selIndex || 0
      if (this.item.data && this.item.data.length) {
        list = this.item.data[index].list || []
      }
      return list
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    }
  }
}
</script>

<style lang="scss" scoped>
.itemActive {
  background-color: white;
  position: relative;
}

.itemActive::after {
  position: absolute;
  content: "";
  top: 18px;
  bottom: 20px;
  left: 5px;
  width: 3px;
  height: 15px;
  margin: auto;
  background: linear-gradient(180deg, #F11E0B 0%, #F77636 100%) !important;
}

.diy-navBar .list {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

.diy-navBar .list .item {
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.diy-navBar .list.column-3 .item {
  width: 33.333333333%;
}

.diy-navBar .list.column-4 .item {
  width: 25%;
}

.diy-navBar .list.column-5 .item {
  width: 20%;
}

.diy-navBar .list .item-image {
  width: 60%;
}

.diy-navBar .list .item-image img {
  width: 100%;
}

.diy-navBar .list .item-text {
  width: 100%;
  padding: 4px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/model/Category.vue